import { DefaultTokenIcon } from '@/components/icons/DefaultTokenIcon';
import { TokenTransferDetails } from './useTransactionBuilderStore';

/**
 * Props for ReviewTokenTransferDetails component
 */
interface ReviewTokenTransferDetailsProps {
  displayAmount: string;
  tokenTransferDetails: TokenTransferDetails;
  recipientLabel: string;
}

/**
 * Component to display token transfer details in the review page
 * Shows "Send [amount] [token] to [recipient]" with styled badges
 */
export function ReviewTokenTransferDetails({
  displayAmount,
  tokenTransferDetails,
  recipientLabel,
}: ReviewTokenTransferDetailsProps): React.ReactElement {
  return (
    <div className="flex gap-[5px] items-center justify-center flex-wrap">
      <p className="font-medium text-[16px] text-zinc-700 dark:text-zinc-300">
        Send
      </p>

      {/* Amount Badge */}
      <div className="bg-zinc-100 dark:bg-zinc-800 flex gap-[10px] items-center justify-center overflow-clip px-[7px] py-[3px] rounded-[14px]">
        <p className="font-medium text-[16px] text-black dark:text-white">
          {displayAmount}
        </p>
      </div>

      {/* Token Badge */}
      <div className="bg-zinc-100 dark:bg-zinc-800 flex gap-[5px] items-center justify-center overflow-clip px-[7px] py-[3px] rounded-[14px]">
        {tokenTransferDetails.asset.logoUrl ? (
          <img
            src={tokenTransferDetails.asset.logoUrl}
            alt={tokenTransferDetails.asset.symbol}
            className="w-[16px] h-[16px] rounded-full"
          />
        ) : (
          <DefaultTokenIcon size={16} />
        )}
        <p className="font-medium text-[16px] text-black dark:text-white">
          {tokenTransferDetails.asset.symbol}
        </p>
      </div>

      <p className="font-medium text-[16px] text-zinc-700 dark:text-zinc-300">
        to
      </p>

      {/* Recipient Badge */}
      <div className="bg-zinc-100 dark:bg-zinc-800 flex gap-[10px] items-center justify-center overflow-clip px-[7px] py-[3px] rounded-[14px]">
        <p className="font-medium text-[16px] text-black dark:text-white">
          {recipientLabel}
        </p>
      </div>
    </div>
  );
}
